import script from "./index-view.vue?vue&type=script&setup=true&lang=ts"
export * from "./index-view.vue?vue&type=script&setup=true&lang=ts"

import "./index-view.vue?vue&type=style&index=0&id=52d21d6e&scoped=true&lang=scss"

import exportComponent from "/Users/macmini/builds/VJ28wZh6/0/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52d21d6e"]])

export default __exports__